/*=========================================================================================
  File Name: moduleMapActions.js
  Description: Map Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Api from "@/helpers/api.js";
import IndexedDB from "@/helpers/IndexedDB.js";

export default {
	closeMapSideBar({commit}) {
		commit("CLOSE_MAP_SIDEBAR");
	},
	openMapSideBar({commit}) {
		commit("OPEN_MAP_SIDEBAR");
	},
	changeToggleMapSidebar({commit}, val) {
		commit("TOGGLE_MAP_SIDEBAR", val);
	},
	openPopupStreeView({commit}, val) {
		commit("OPEN_STREETVIEW", val);
	},
	changeMapStyle({commit}, theme) {
		commit("CHANGE_MAP_STYLE", theme.name);
	},
	changeTrafficLayer({commit}, val) {
		commit("CHANGE_TRAFFIC_LAYER", val);
	},
	getExecutedRoute({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/executed/route", payload)
				.then((response) => {
					commit("SET_EXECUTE_ROUTE", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	geocoder({commit}, {country, city, address, department}) {
		const payload = {country, city, address, department};
		return new Promise((resolve, reject) => {
			Api.post("/geocoder", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
					throw new Error(err);
				});
		});
	},
	geoinverso({commit}, {country, cy, cx}) {
		const payload = {country, cy, cx};
		return new Promise((resolve, reject) => {
			Api.post("/geoinverso", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
					throw new Error(err);
				});
		});
	},
	async saveConfigurationOnIndexedDB({commit, state, dispatch}) {
		try {
			let optionsProgramedRoute = state.optionsProgramedRoute;
			let optionsExecutedRoute = state.optionsExecutedRoute;
			const val = await dispatch("validate");
			if (val) {
				optionsProgramedRoute = val.optionsProgramedRoute;
				optionsExecutedRoute = val.optionsExecutedRoute;
				await IndexedDB.update("map_config", {optionsProgramedRoute, optionsExecutedRoute}, "confi");
			} else {
				await IndexedDB.save("map_config", {optionsProgramedRoute, optionsExecutedRoute}, "confi");
			}
			commit("SAVE_OPTIONS_PROGRAMED_ROUTE", optionsProgramedRoute);
			commit("SAVE_OPTIONS_EXECUTED_ROUTE", optionsExecutedRoute);
		} catch (error) {
			throw new Error(error);
		}
	},
	async updateConfigurationOnIndexedDB({commit, state}) {
		try {
			const {optionsProgramedRoute, optionsExecutedRoute} = {...state};
			await IndexedDB.update("map_config", {optionsProgramedRoute, optionsExecutedRoute}, "confi");
			commit("SAVE_OPTIONS_PROGRAMED_ROUTE", optionsProgramedRoute);
			commit("SAVE_OPTIONS_EXECUTED_ROUTE", optionsExecutedRoute);
		} catch (error) {
			throw new Error(error);
		}
	},
	geMapConfig() {
		return IndexedDB.getAll("map_config");
	},
	validate() {
		return IndexedDB.getKey("map_config", "confi");
	},
	closePopupRouteLegends({commit}, val) {
		commit("TOGGLE_ROUTES_LEGENDS", val);
	},
	locatePanicAlarm({commit}, notification) {
		commit("LOCATE_PANIC_ALARM", notification);
	},
};
